import { lessonDetailsActionTypes } from './Constants';

export function getLessonDetails(lessonId, userId) {
	return {
		type: lessonDetailsActionTypes.GET_SINGLE_LESSON_DETAILS_REQUEST,
		payload: { lessonId, userId },
	};
}

export function getLessonDetailsSuccess(data) {
	return {
		type: lessonDetailsActionTypes.GET_SINGLE_LESSON_DETAILS_SUCCESS,
		payload: { data },
	};
}

export function getLessonDetailsError() {
	return {
		type: lessonDetailsActionTypes.GET_SINGLE_LESSON_DETAILS_ERROR,
	};
}

export function getScheduledLessons(lessonId, userId) {
	return {
		type: lessonDetailsActionTypes.GET_SCHEDULE_LESSONS_REQUEST,
		payload: { lessonId, userId },
	};
}

export function getScheduledLessonsSuccess(data) {
	return {
		type: lessonDetailsActionTypes.GET_SCHEDULE_LESSONS_SUCCESS,
		payload: { data },
	};
}

export function getScheduledLessonsError() {
	return {
		type: lessonDetailsActionTypes.GET_SCHEDULE_LESSONS_ERROR,
	};
}

export function deleteScheduledLesson(data) {
	return {
		type: lessonDetailsActionTypes.DELETE_SCHEDULED_LESSON_REQUEST,
		payload: { data },
	};
}

export function deleteScheduledLessonSuccess() {
	return {
		type: lessonDetailsActionTypes.DELETE_SCHEDULED_LESSON_SUCCESS,
	};
}

export function deleteScheduledLessonError() {
	return {
		type: lessonDetailsActionTypes.DELETE_SCHEDULED_LESSON_ERROR,
	};
}

export function setSignedUp(signedUp) {
	return {
		type: lessonDetailsActionTypes.SET_LESSON_SIGNED_UP,
		payload: { signedUp },
	};
}

export function getSignedUp() {
	return {
		type: lessonDetailsActionTypes.GET_LESSON_SIGNED_UP,
	};
}

export function clearLessonDetailsData() {
	return {
		type: lessonDetailsActionTypes.CLEAR_LESSON_DETAILS_DATA,
	};
}
